import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Wrench } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 60_000;

/**
 * Top-of-page banner shown only while `maintenance_mode = true` on the public
 * feature flags doc. Polls every 60s so it appears within a minute of an admin
 * flipping the switch and disappears within a minute of flipping it back off.
 *
 * Rendered globally (above the navbar) so users always see it, and so write
 * actions that 503 are accompanied by an in-flow explanation.
 */
const MaintenanceBanner = () => {
  const [flags, setFlags] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () =>
      axios
        .get(`${BACKEND_URL}/api/admin/feature-flags`)
        .then((r) => !cancelled && setFlags(r.data))
        .catch(() => {});
    load();
    const id = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!flags?.maintenance_mode) return null;

  const message =
    flags.maintenance_message ||
    "We're tidying up some data — back in a few minutes.";

  return (
    <div
      role="status"
      data-testid="maintenance-banner"
      className="w-full bg-gradient-to-r from-[#5b35a8] via-[#7042cc] to-amber-500 text-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-2 text-sm font-medium text-center">
        <Wrench className="h-4 w-4 flex-shrink-0" />
        <span className="truncate">{message}</span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
